import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import {
  provideLocalMcqSelection,
  provideQuestionItemsForm,
  provideSingleAttemptSelfGradingSelection,
  QUESTION_CONTEXT,
  QuestionStoreModel,
} from '@examdojo/question';
import { distinctUntilChanged, map, Observable } from 'rxjs';
import { QuestionItemsGradingViewerComponent } from '../question-items-grading-viewer/question-items-grading-viewer.component';
import { QUESTION_ITEMS_DATA, SimpleQuestionItemsViewerFormService } from './simple-question-items-viewer-form.service';

@Component({
  selector: 'dojo-question-content-readonly',
  standalone: true,
  imports: [QuestionItemsGradingViewerComponent],
  template: `<dojo-question-items-grading-viewer />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: QUESTION_ITEMS_DATA,
      useFactory: (component: QuestionContentReadonlyComponent) => {
        return component.question$.pipe(
          distinctUntilChanged((prev, curr) => prev?.id === curr?.id),
          map((question) => question?.question_items ?? []),
        );
      },
      deps: [forwardRef(() => QuestionContentReadonlyComponent)],
    },
    {
      provide: QUESTION_CONTEXT,
      useValue: {
        showHints: false,
        optionsSelectable: false,
        revealSolutionOnWrongAnswer: true,
        showMarks: false,
        showGradingState: false,
      },
    },
    provideQuestionItemsForm(SimpleQuestionItemsViewerFormService),
    provideLocalMcqSelection(),
    provideSingleAttemptSelfGradingSelection(),
  ],
})
export class QuestionContentReadonlyComponent {
  readonly question = input.required<QuestionStoreModel>();

  readonly question$: Observable<QuestionStoreModel | undefined> = toObservable(this.question);
}
